module.exports = __webpack_public_path__ + "img/maps-marker-telephone.e9472770.svg";